import Vue from "vue";
import App from "./App.vue";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "@mdi/font/css/materialdesignicons.css";
import router from "./router";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import store from "./store";

export function toggleModoOscuro(activar) {
  try {
    document.documentElement.setAttribute("data-tema", activar ? "oscuro" : "");
  } catch (error) {
    console.warn("Error al cambiar tema:", error);
  }
}

try {
  const temaGuardado = localStorage.getItem("tema") || "claro";
  document.documentElement.setAttribute(
    "data-tema",
    temaGuardado === "oscuro" ? "oscuro" : ""
  );
} catch (error) {
  console.warn("Error al cargar tema:", error);
}

Vue.use(Buefy);
Vue.config.productionTip = false;

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
